import { JsonViewer } from "@/components/ui/json-viewer";
import { McpErrorCard } from "./McpErrorCard";

interface McpResponseAnalysisProps {
  parsedResponse: {
    error?: {
      code: number;
      message: string;
      data?: unknown;
    };
    result?: unknown;
  };
}

export function McpResponseAnalysis({
  parsedResponse,
}: McpResponseAnalysisProps) {
  return (
    <div className="space-y-3 h-full">
      {parsedResponse.error && <McpErrorCard error={parsedResponse.error} />}

      {!!parsedResponse.result && (
        <JsonViewer
          data={parsedResponse.result}
          title="Response"
          className="h-full"
          defaultExpanded={true}
        />
      )}
    </div>
  );
}
